[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 4,
                "y": 8,
                "key": "xMSu7"
            },
            {
                "x": 2,
                "y": 8,
                "key": "4St2N"
            },
            {
                "x": 2,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 1,
                "y": 7,
                "key": "IGckT"
            },
            {
                "x": 1,
                "y": 6,
                "key": "RBCT-"
            },
            {
                "x": 0,
                "y": 6,
                "key": "4o-AQ"
            },
            {
                "x": 0,
                "y": 4,
                "key": "8JfdP"
            },
            {
                "x": 1,
                "y": 4,
                "key": "6zmsi"
            },
            {
                "x": 1,
                "y": 3,
                "key": "0aboz"
            },
            {
                "x": 4,
                "y": 3,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 4,
                "y": 4,
                "key": "Y_QtY"
            },
            {
                "x": 8,
                "y": 4,
                "key": "87Arv"
            },
            {
                "x": 8,
                "y": 3,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 11,
                "y": 3,
                "key": "7lYqQ"
            },
            {
                "x": 11,
                "y": 4,
                "key": "NjyBq"
            },
            {
                "x": 12,
                "y": 4,
                "key": "-6cht"
            },
            {
                "x": 12,
                "y": 6,
                "key": "aS9jA"
            },
            {
                "x": 11,
                "y": 6,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 7,
                "key": "5QUqG"
            },
            {
                "x": 11,
                "y": 8,
                "key": "yISFx"
            },
            {
                "x": 10,
                "y": 8,
                "key": "VjHMM"
            },
            {
                "x": 8,
                "y": 8,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 8,
                "y": 9,
                "key": "SNZ-8"
            },
            {
                "x": 4,
                "y": 9,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]